<button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
  <i class="bi bi-three-dots bi-large"></i>
</button>
<ul class="dropdown-menu">

  @if (withdrawAllowed()) {
    <li><a class="dropdown-item pt-1 pb-1"
      (click)="applyAction(requestStatusActionsEnum.Withdrawn)"
    translate="Request.Status.RequestOptions.WithdrawRequest"></a>
  </li>
}

@if (downloadAllowed()) {
  <li><a class="dropdown-item pt-1 pb-1"
    (click)="applyAction(requestStatusActionsEnum.Download)"
  translate="Request.Status.RequestOptions.DownloadRequest"></a></li>
}

@if (purgeAllowed()) {
  <li><a class="dropdown-item pt-1 pb-1"
  (click)="applyAction(requestStatusActionsEnum.Purge)" translate="Request.Status.RequestOptions.PurgeRequest"></a>
</li>
}

@if (restoreAllowed()) {
  <li><a class="dropdown-item pt-1 pb-1"
    (click)="applyAction(requestStatusActionsEnum.Restore)"
  translate="Request.Status.RequestOptions.RestoreRequest"></a>
</li>
}

@if (deleteAllowed()) {
  <li><a class="dropdown-item pt-1 pb-1"
  (click)="applyAction(requestStatusActionsEnum.Delete)" translate="Request.Status.RequestOptions.DeleteRequest"></a>
</li>
}

@if (allowedToChangeOwnership) {
  <li><a class="dropdown-item pt-1 pb-1"
    (click)="applyAction(requestStatusActionsEnum.BecomeOwner)"
  translate="Request.Status.RequestOptions.BecomeOwner"></a></li>
}

<li ><a class="dropdown-item pt-1 pb-1" (click)="applyAction(requestStatusActionsEnum.Viewlog)"
translate="Request.Status.RequestOptions.ViewLog"></a></li>
</ul>